import { css } from '@emotion/react'

const S = {
  page: css`
    display: flex;
    flex-direction: column;
    height: 100dvh;
    background: var(--White);
    color: var(--Colors-Gray-900);
    word-break: keep-all;
  `,

  top: css`
    display: flex;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
    height: 56px;
    padding: 0 16px;
    border-bottom: 1px solid var(--Colors-Gray-300);
  `,

  back: css`
    display: inline-flex;
  `,

  topTitle: css`
    font-size: 16px;
    line-height: 24px;
    font-weight: 700;
  `,

  scroll: css`
    flex: 1;
    min-height: 0;
    overflow-y: auto;
  `,

  // 학년 머리도 Gray-100 이라 아래 선으로 학습지 머리와 가른다.
  worksheetHead: css`
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
    gap: 4px;
    padding: 16px;
    border-bottom: 1px solid var(--Colors-Gray-300);
    background: var(--Colors-Gray-100);
  `,

  worksheetTitle: css`
    font-size: 16px;
    line-height: 24px;
    font-weight: 700;
  `,

  sub: css`
    font-size: 12px;
    line-height: 18px;
    color: var(--Colors-Gray-600);
  `,

  gradeHead: css`
    display: flex;
    align-items: center;
    gap: 12px;
    width: 100%;
    height: 48px;
    padding: 0 16px;
    border-bottom: 1px solid var(--Colors-Gray-300);
    background: var(--Colors-Gray-100);
    font-size: 14px;
    line-height: 21px;
    font-weight: 700;
    text-align: left;
  `,

  gradeCount: css`
    font-weight: 400;
    color: var(--Colors-Gray-600);
  `,

  // 왼쪽은 학년 머리의 학년 글자에 맞춘다(16 + 화살표 20 + 12).
  row: css`
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;
    height: 56px;
    padding: 0 16px 0 48px;
    border-bottom: 1px solid var(--Colors-Gray-200);
    text-align: left;
  `,

  name: css`
    flex: 1;
    font-size: 16px;
    line-height: 24px;
  `,

  notice: css`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
    padding: 64px 16px;
    text-align: center;
  `,

  noticeTitle: css`
    font-size: 16px;
    line-height: 24px;
    font-weight: 700;
  `,

  retry: css`
    margin-top: 8px;
    padding: 8px 12px;
    font-size: 14px;
    line-height: 21px;
    color: var(--Colors-Sky-600);
    text-decoration: underline;
  `,

  nextBar: css`
    flex-shrink: 0;
    padding: 12px 16px calc(24px + env(safe-area-inset-bottom, 0px));
    border-top: 1px solid var(--Colors-Gray-200);
    background: var(--White);
  `,
}

export default S
